import { Outlet, createRootRoute } from '@tanstack/react-router';

import { EnsureUser } from '@/components/EnsureUser.tsx';
import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';

export const Route = createRootRoute({
  component: () => (
    <div className="h-screen bg-background text-foreground flex flex-col">
      <Header />
      <EnsureUser />
      <main className="flex-1 flex overflow-auto">
        <Outlet />
      </main>
      <Footer />
    </div>
  ),
});
